import React from "react";
import { Container, ContainerFW } from "../global";
import { Heading } from "../Heading";
import { TitleWithCard } from "./TitleWithCard";
export const TitleWithTwoCards = ({ cards, mainTitle }) => (React.createElement(ContainerFW, null,
    React.createElement("div", { className: "title-with-two-cards-root" },
        React.createElement(Container, null,
            React.createElement(Heading, { design: "h2-regular" }, mainTitle),
            React.createElement("div", { className: "title-with-two-cards-root__cardsWrapper" }, cards.length > 0 && cards.map((card) => (React.createElement(TitleWithCard, { key: `unique${card.title}`, ...card }))))))));
